import { Environment } from '@thiememeulenhoff/types';
import { deployUrl } from './deploy-url';
import { ChannelsEnvironmentType } from './environment.type';

export const environment: ChannelsEnvironmentType = {
  environment: Environment.Test,
  production: true,
  deployUrl: deployUrl(),
  analytics: {
    tagManagerId: '',
    tagManagerAuth: '',
    tagManagerPreview: '',
  },
  thas: {
    environment: 'test',
    token: '940107d25653f86746b2a0fce732025628bbccd03cb19f19f66e237e4e507ef8',
  },
  auth: {
    environment: Environment.Test,
    clientId: 'channels',
    clientSecret: '0ff6e4c1-0a80-4930-87d1-bd9b21f10373',
    useUserCookie: false,
  },
  unleash: {
    instance: 'eu.app.unleash-hosted.com/euee0007',
    clientKey:
      '*:development.9fcfa139893173c16ee5fae24b057c205de41bf1da110a43f428a340',
    environment: 'development',
    refreshInterval: 5 * 60, // 5 minutes
    metricsInterval: 15 * 60, // 15 minutes
  },
};
